import { Theme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    gap: theme.spacing(4),
  },
  leftContainer: {
    width: '65%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  topContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.text.white,
    padding: theme.spacing(1, 2),
    borderRadius: theme.spacing(1),
    minHeight: theme.spacing(9.5),
  },
  bottomContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  rightContainer: {
    width: '35%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  helpContainer: {
    display: 'flex',
    backgroundColor: theme.palette.text.white,
    padding: theme.spacing(0, 4),
    borderRadius: theme.spacing(1),
    minHeight: theme.spacing(7),
    alignItems: 'center',
  },
  activityLogContainer: {
    backgroundColor: theme.palette.text.white,
    borderRadius: theme.spacing(1),
    height: theme.spacing(47.875),
    padding: theme.spacing(4),
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  heading: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    color: theme.palette.labraText.primary,
    fontFamily: theme.typography.fontFamily,
    letterSpacing: '0.15px',
  },
  svgBackground: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: theme.spacing(45),
  },
  labraIcon: {
    height: theme.spacing(9.75),
    width: theme.spacing(26.75),
  },
  activityHeading: {
    marginTop: theme.spacing(2),
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    color: theme.palette.textField.main,
    fontFamily: theme.typography.fontFamily,
    letterSpacing: '0.25px',
  },
  infoIcon: {
    height: theme.spacing(2),
    width: theme.spacing(2),
    fontSize: '16px',
  },
  qAndAParentWrapper: {
    display: 'flex',
  },
  sidePanelInfoIcon: {
    width: theme.spacing(3),
    height: theme.spacing(2.5),
    fontSize: '24px',
  },
  sidePanelTitleText: {
    fontSize: '22px',
    lineHeight: '28px',
  },
}))
